import DEFINES from '@/defines';
import i18n from "@/i18n";

const consumerAuthentication = {
    methods:{
        async checkEmail()
        {
            try {
              if (!this.$refs.emailForm.validate()) {
                return false;
              }
              await this.$store
                .dispatch("auth/checkEmail", {
                  phone: this.phone,
                  email: this.email,
                  company_id: this.company.id,
                  redirectTo: this.getCurrentRouteUrl()
                })
                .then((response) => {
                  this.is_email_verified = response.is_email_verified;
                  this.phone = response.phone;
                  if (response.shouldVerify) {
                    this.code = response.otp
                    return (this.current_step =
                      DEFINES.ENROLLMENT_STEPS.VERIFICATION);
                  }
                  return (this.current_step = DEFINES.ENROLLMENT_STEPS.ASK_PASSWORD);
                });
            } catch (error) {
              this.$store.dispatch("app/showMessage", {
                message: error.message,
                color: "error",
              });
            }
        },

        async resendVerification(
            is_phone = false,
            redirectTo = null,
            showMessage = true
          )
        {
            try {
              var redirectingPath = this.getCurrentRouteUrl();
              if (is_phone) {
                var payload = {
                  phone: this.phone,
                  key: this.session_key,
                  company_id: this.company.id,
                  redirectTo:redirectingPath
                };
              } else {
                var payload = {
                  email: this.email,
                  key: this.session_key,
                  company_id: this.company.id,
                  redirectTo:redirectingPath
                };
              }

              var response = await this.$store.dispatch("auth/resendVerification", payload);

              if(response && response.otp){
                this.code = response.otp
              }
              if (redirectTo) {
                this.current_step = redirectTo;
              }
              if (showMessage) {
                this.$store.dispatch("app/showMessage", {
                  message: i18n.t(
                    "enrollment.steps.verification.verification_code_resent"
                  ),
                  color: "success",
                });
              }
            } catch (error) {
              this.$store.dispatch("app/showMessage", {
                message: error.message,
                color: "error",
              });
            }
        },
        /**
         * On reset password
         * 1. send verification email
         * 2. Navigate to verification steps
         */
        async resetPassword(is_phone = false)
        {
          if(is_phone && !this.isPhoneValid){
            this.$store.dispatch("app/showMessage", {
              message: i18n.t("enrollment.steps.reset_password.phone_invalid"),
              color: "error",
            });
            return;
          }
          this.resettingPassword = true;
          var redirectingPath = this.getCurrentRouteUrl();
          try {
            if (is_phone) {
                var payload = {
                phone: this.phone,
                key: this.session_key,
                company_id: this.company.id,
                redirectTo:redirectingPath
                };
            } else {
                var payload = {
                email: this.email,
                key: this.session_key,
                company_id: this.company.id,
                redirectTo:redirectingPath
                };
            }
            await this.$store
                .dispatch("auth/resendVerification", payload)
                .then((response) => {
                    if(response && response.otp){
                        this.code = response.otp
                    }
                    if (is_phone) {
                        this.current_step = DEFINES.ENROLLMENT_STEPS.ASK_OTP;
                    } else {
                        this.current_step = DEFINES.ENROLLMENT_STEPS.VERIFICATION;
                    }
                });
            } catch (error) {
            this.$store.dispatch("app/showMessage", {
                message: error.message,
                color: "error",
            });
            }
        },

        matchPasswords() {
            if (this.password != this.confirm_password) {
                throw {
                    message: i18n.t("rms.field.entered.passwords.not_matched"),
                };
            }
        },
        async updateConsumer() {
          if (!this.$refs.basicDetailsForm.validate()) {
            return false;
          }
          try {
            var response = await this.doUpdateConsumer();
            this.current_step = DEFINES.ENROLLMENT_STEPS.WANT_TO_SET_PASSWORD;
          } catch (error) {
            this.$store.dispatch("app/showMessage", {
              message: error.message,
              color: "error",
            });
          }
        },
        async doUpdateConsumer(){
          var response = await this.$store.dispatch(
            "consumer/update",
            this.consumer
          );
          return response;
        },
        getCurrentRouteUrl(){
          return this.$router.currentRoute.fullPath;
        }
    }
}


export {consumerAuthentication};
